import { render, staticRenderFns } from "./useRouter.vue?vue&type=template&id=9652c6ec&scoped=true&"
import script from "./useRouter.vue?vue&type=script&lang=js&"
export * from "./useRouter.vue?vue&type=script&lang=js&"
import style0 from "./useRouter.vue?vue&type=style&index=0&id=9652c6ec&lang=scss&scoped=true&"
import style1 from "./useRouter.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9652c6ec",
  null
  
)

export default component.exports